export default "__VITE_ASSET__BpbN9Y8d__"